
import { useState } from "react"
import styled from "styled-components"
import InputText from "../../shared/input/new/InputText"
import Btn from "../../shared/button/Btn"
import { useLocation } from "react-router-dom"
import { useEffect } from "react"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { showModal } from "../../../features/modal/modalSlice"
import InputDate from "../../shared/input/new/InputDate"
import InputTextarea from "../../shared/input/new/InputTextarea"
import InputCityTown from "../../shared/input/new/InputCityTown"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import InputSelectMultiple from "../../shared/input/new/InputSelectMultiple"

import ehliyetOptions from "../../../utils/ehliyetOptions"
import srcOptions from "../../../utils/srcOptions"
import PageTopTitle from "../../shared/PageTopTitle"
import { addAdminUye, getUserPhoneNumberUnique, getUserTcApprove } from "../../../features/admin2/admin2Slice"
import moment from "moment"
import InputSelect from "../../shared/input/new/InputSelect"
import SmallSpinner from "../../shared/spinners/SmallSpinner"
import ImageUploader from "../../docs/ImageUploader"
import { validateFile } from "../../../helper/docs/validateFile"
import { addNewDevamliDriver } from "../../../features/joblist/jobListSlice"
import InputPhoneFormat from "../../shared/input/new/InputPhoneFormat"
import { createRegularDriver, getTCQuery, getUserTcApproveV2, setIsTcApprove } from "../../../features/driversVehicles/driversVehiclesSlice"
import { BsCheck2 } from "react-icons/bs";

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 900px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .content{
            padding: 40px 0 20px;
            width: 900px;
            display: flex;
            flex-direction: column;
            align-items: center;
            height: auto;
            max-height: 600px;
            overflow: auto !important;

            h2{
                font-size: 18px;
                font-weight: 600;
                text-align: center;
                width: 440px;

                &:first-child{
                    margin-bottom: 20px !important;
                }

            }

            .doc-title{
                margin-top: 40px !important;

            }

    .doc-container{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        gap: 30px;
        width: 440px;
        padding: 20px 0;

        &::-webkit-scrollbar {
            width: 0;
            width: 8px;
        }
        &::-webkit-scrollbar-thumb {
            background-color: ${({theme})=> theme.scrollThumbColor};
            border-radius: 10px;
        }
        &::-webkit-scrollbar-track {
            background-color: transparent;
        }
           
        
        .doc-item{
            width: 100%;
            height: 400px;
            border: 1px solid ${({theme}) => theme.mainTextColor};
            border-radius: 10px;
            overflow: hidden;
            
            .doc-item-top{
                width: 100%;
                height: 50px;
                border: 1px solid ${({theme}) => theme.mainBorderColor};
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-lg);

                .action{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;

                        span{

                            &:first-child{
                                width: 60px;
                            }
                        }


                        .delete-btn{
                            font-size: var(--font-size-sm);
                            font-weight: var(--font-weight-lg);
                            /* background-color: var(--color-main); */
                            color: #fff;
                            color: var(--color-main);
                            border: 1px solid var(--color-main);
                            padding: 5px 7px;
                            border-radius: 5px;
                            cursor: pointer;
                            margin-right: 10px;
                            transition: .2s;

                            &:hover{
                                background-color: var(--color-main);
                                color: #fff;
                            }
                        }
                    }
            }
        }

        .new-select-item{
            border-color: red;
            border-width: 2px;

            .new-select-item-top{
                background-color: #ff000040;
            }
        }

    }

            .input-grp{
                width: 440px;
                display: flex;
                align-items: flex-start;
                justify-content: space-between;
                gap: 5px;
                margin-bottom: 20px;

                &:nth-child(1), &:nth-child(4){
                    flex-direction: row;
                    justify-content: space-between;
                    gap: 20px;
                }

                .input-column{
                    display: flex;
                    flex-direction: column;
                    gap: 5px;

                    .phone-border{
                        border: 1px solid ${({theme}) => theme.mainBorderColor};
                        padding: 10px 15px;
                        border-radius: 10px;
                    }
                }

                input{
                    border: 1px solid ${({theme}) => theme.mainBorderColor};
                    border-radius: 5px;
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-md);
                }

                p{
                    font-size: 10px;
                    color: var(--color-main);
                }
                .approve{
                    color: #059c05;
                    display: flex;
                    align-items: center;
                }

            }

         

            .tc-btn-error{
                font-size: 12px;
                color: var(--color-main);
                padding-bottom: 10px;
            }

         
        }

        .button-grp{
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: auto;
            margin-bottom: 30px;
            gap: 40px;
        }
    }
`


const AddRegularDriverModal = () => {

    const {modalLocation } = useSelector(state => state.modal)

    const {queriedPhoneNumberForRegularDriver, isLoadingGetUserTcApproveV2, isTCApprove, isLoadingCreateRegularDriver, isLoadingGetTCQuery, queriedTCKN } = useSelector(state => state.driversVehicles)

    const { lockScroll, unlockScroll } = useScrollLock();

    const [isTCKNQueried, setIsTCKNQueried] = useState(false)

    const dispatch = useDispatch()
    const location = useLocation()

    const [isSubmitted, setIsSubmitted] = useState(false)

    const [isTcBtnClicked, setIsTcBtnClicked] = useState(false)

    const [ehliyetTypes, setEhliyetTypes] = useState([])
    const [srcTypes, setSrcTypes] = useState([])
    const [cityTown ,setCityTown] = useState(null)

    const [TCKN, setTCKN] = useState("")
    const [adSoyadUnvan, setAdSoyadUnvan] = useState("")
    const [dogumTarihi, setDogumTarihi] = useState("")
    const [adressContent, setAdressContent] = useState("")


    const [fileList, setFileList] = useState([
        {
            selectedFile: null,
            loadedBefore:  null,
            fileTypeName: "Kimlik",
            staticValue: "kimlik"
        },
        {
            selectedFile: null,
            loadedBefore:  null,
            fileTypeName: "Ehliyet",
            staticValue: "ehliyet"
        },
        {
            selectedFile: null,
            loadedBefore:  null,
            fileTypeName: "SRC Belgesi",
            staticValue: "src"
        },
        {
            selectedFile: null,
            loadedBefore:  null,
            fileTypeName: "Referans Faturası",
            staticValue: "fatura"
        },
        {
            selectedFile: null,
            loadedBefore:  null,
            fileTypeName: "Vergi Levhası",
            staticValue: "vergiLevhası"
        },
        {
            selectedFile: null,
            loadedBefore:  null,
            fileTypeName: "Diğer-1",
            staticValue: "diğer-1"
        },
        {
            selectedFile: null,
            loadedBefore: null,
            fileTypeName: "Diğer-2",
            staticValue: "diğer-2"
        },
    ])

    // useEffect(() => {
    //     if(queriedTCKN.TCKN === TCKN && queriedTCKN.isExist === false){
    //         setIsTCKNQueried(true)
    //     }
    // },[queriedTCKN, TCKN])


            //! bu modal açıldığnda ekran ı lock lamak için
           useEffect(() => {
            lockScroll()
    
            return () => {
                unlockScroll()
            }
        }, [lockScroll, unlockScroll])
    
        //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
        useEffect(() => {
            if (location.pathname !== modalLocation) {
                dispatch(showModal(null))
            }
        }, [dispatch, location.pathname, modalLocation])

    const handleTCApprove = () => {
        setIsTcBtnClicked(true)

        if(TCKN.length === 11 && adSoyadUnvan && dogumTarihi){

            
            const data = {
                tckn: TCKN,
                adSoyadUnvan: adSoyadUnvan,
                dogumTarihi: dogumTarihi.split("-")[0]
            }
            
            dispatch(getUserTcApproveV2(data))
            
        }



    }

    const handleFileSelect = async (index, files) => {
    
      const file = await validateFile({file: files[0], maxSize: 5 * 1024 * 1024, allowedTypes:['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']})
    
      if(file){
        // Tüm kontroller başarılıysa, dosyayı fileList'e ekliyoruz
        const newUploads = [...fileList];
        newUploads[index].selectedFile = file;
        setFileList(newUploads);
      };
    
    }

    const handleSubmit = () => {

        setIsSubmitted(true)

        if(queriedPhoneNumberForRegularDriver && TCKN.length === 11 && adSoyadUnvan && dogumTarihi && cityTown?.city && cityTown?.town && ehliyetTypes.length > 0 && srcTypes.length > 0){


        const formattedEhliyetTypes = ehliyetTypes.map(item => {
            return {
                Ehliyet:item.value
            }
        })

        const formattedSrcTypes = srcTypes.map(item => {
            return {
                Ehliyet:item.value
            }
        })
        


         const formData = new FormData()
            formData.append("phoneNumber", queriedPhoneNumberForRegularDriver)
            formData.append("TCKN", TCKN)
            formData.append("AdSoyadUnvan", adSoyadUnvan)
            formData.append("DogumTarihi", dogumTarihi)
            formData.append("AdressContent", adressContent)
            formData.append("il", cityTown.city)
            formData.append("ilce", cityTown.town)
            formData.append("SrcTypes", JSON.stringify(formattedEhliyetTypes))
            formData.append("EhliyetTypes", JSON.stringify(formattedSrcTypes))


            formData.append("SrcBelgesi", fileList[2].selectedFile)
            formData.append("Ehliyet", fileList[1].selectedFile)
            formData.append("Kimlik", fileList[0].selectedFile)
            formData.append("Diger1", fileList[5].selectedFile)
            formData.append("Diger2", fileList[6].selectedFile)
            formData.append("Fatura", fileList[3].selectedFile)
            formData.append("VergiLevhası", fileList[4].selectedFile)

        dispatch(createRegularDriver({regularData: formData, phoneNumber: queriedPhoneNumberForRegularDriver.slice(2)}))
        }

        // dispatch(showModal("addAracQuestion"))
    }

    const handleTCKN = (e) => {
          const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');

  // İlk 11 haneyle sınırla (TCKN max 11 karakterdir)
  if (onlyNumbers.length <= 11) {
    setTCKN(onlyNumbers);
  }
    }

    useEffect(() => {

        return () => {
            dispatch(setIsTcApprove(false))
        }
    },[])

  return (
<ModalContainer>
        <div className="modal" onClick={() => dispatch(handleActiveSelect(null))}>
            <PageTopTitle title={"Sürücü Ekle"}/>
            <div className="content">
                <h2>Sürücü Bilgileri</h2>
                <div className="input-grp">
                    <div className="input-column">
                        <div className="phone-border">
                            <div style={{fontSize: "14px", fontWeight: 600}}>Telefon Numarası: {queriedPhoneNumberForRegularDriver}</div>
                        </div>
                    </div> 
                </div>
                

                <div className="input-grp">
                    <div className="input-column">
                        <InputText data={adSoyadUnvan} setData={(e) => setAdSoyadUnvan(e.target.value.replace(/[^a-zA-ZğüşöçİĞÜŞÖÇ\s]/g, ''))} inputWidth={"440px"} labelText="Adı Soyadı" name={"adSoyadUnvan"}/>
                        {
                            (!adSoyadUnvan && isSubmitted) &&
                            <p>Ad Soyad bilgisi girilmesi zorunludur</p>
                        }
                    </div>
                </div>

                <div className="input-grp">
                    <InputDate data={dogumTarihi} setData={(e) => setDogumTarihi(e.target.value)} inputWidth={"440px"} labelText="Doğum Tarihi" name={"dogumTarihi"}/>
                </div>

                <div className="input-grp">
                    <div className="input-column">
                        <InputText data={TCKN} setData={(e) => handleTCKN(e)} inputWidth={"260px"} labelText="TC No" name={"TCKN"}/>
                        {
                            (!TCKN && isSubmitted) &&
                            <p>TC No bilgisi girilmesi zorunludur</p>
                        }
                        {
                            (TCKN && TCKN?.length !== 11 && isSubmitted) &&
                            <p>TC No 11 haneli olmalıdır.</p>
                        }
                    </div>
                    {
                        !isTCApprove ?
                        <Btn bgColor="transparent" borderColor="#E85446" color="#E85446" width={"160px"} handleClick={() =>  handleTCApprove()}>{isLoadingGetUserTcApproveV2 ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/>  : "Doğrula"}</Btn>
                        :
                        <Btn bgColor="transparent" borderColor="#2dad38" color="#2dad38" width={"160px"} cursor="initial" handleClick={() => {}}><BsCheck2 style={{fontSize: "1.6rem"}}/> Doğrulandı</Btn>
                    }
                    {/* {
                        !isTCKNQueried ?
                        <Btn bgColor="transparent" borderColor="#E85446" color="#E85446" width={"160px"} cursor="initial" handleClick={() => {dispatch(getTCQuery(TCKN))}}>{isLoadingGetTCQuery ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Sorgula"}</Btn>
                        :
                        <Btn bgColor="transparent" borderColor="#2dad38" color="#2dad38" width={"160px"} cursor="initial" handleClick={() => {}}><BsCheck2 style={{fontSize: "1.6rem"}}/> Kullanılabilir</Btn>
                    } */}
                </div>
                    {
                        (isTcBtnClicked && (!TCKN || !adSoyadUnvan || !dogumTarihi)) &&
                        <p className="tc-btn-error">
                            TC Numarası Doğrulaması için TC Numarası, Ad Soyad ve Doğum Tarihi bilgisini uygun bir şekilde giriniz.  
                        </p>
                    }

                <div className="input-grp">
                    <InputTextarea data={adressContent} setData={(e) => setAdressContent(e.target.value)} inputWidth={"440px"} labelText="Adres" name={"adressContent"}/>
                    {/* {
                        (!formData.adres && isSubmitted) &&
                        <p>Adres bilgisi girilmesi zorunludur</p>
                    } */}
                </div>

                <div className="input-grp">
                    <div className="input-column">
                        <InputCityTown data={cityTown?.location} setData={setCityTown} inputWidth={"440px"} labelText="İl/İlçe" name={"cityTown"}/>
                        {
                            (!cityTown?.location && isSubmitted) &&
                            <p>İl/İlçe bilgisi girilmesi zorunludur</p>
                        }
                        </div>
                </div>

                <div className="input-grp">
                    <InputSelectMultiple data={ehliyetTypes} setData={setEhliyetTypes} inputWidth={"440px"} labelText="Ehliyet Türleri" name={"ehliyetTypes"} options={ehliyetOptions}/>
                    {
                        (ehliyetTypes < 1 && isSubmitted) &&
                        <p>Ehliyet bilgisi girilmesi zorunludur</p>
                    }
                </div>
                <div className="input-grp">
                    <InputSelectMultiple data={srcTypes} setData={setSrcTypes} inputWidth={"440px"} labelText="SRC Türü" name={"srcTypes"} options={srcOptions}/>
                    {
                        (srcTypes.length < 1 && isSubmitted) &&
                        <p>SRC bilgisi girilmesi zorunludur</p>
                    }
                </div>

                <h2 className="doc-title">Sürücü Belgeleri</h2>

                <div className="doc-container">
                                     {
                    fileList.map((fileItem, index) => {
                        let previewSrc;
                        let isPdf;
                        if (fileItem.selectedFile) {
                            isPdf = fileItem.selectedFile.type === "application/pdf"
                            previewSrc = URL.createObjectURL(fileItem.selectedFile);

                        } else if (fileItem.loadedBefore) {
                          previewSrc = `${process.env.REACT_APP_API_IMG_URI}${fileItem.loadedBefore}`;
                        } else {
                          previewSrc = "question";
                        }

                        return (
                            <div className={fileItem.selectedFile ? "new-select-item doc-item" : "doc-item"}>
                                 <div className={fileItem.selectedFile ? "new-select-item-top doc-item-top" : "doc-item-top"}>
                                    {fileItem.selectedFile ? (
                                        <p>Yeni Seçilen Belge: {fileItem.selectedFile.name} - ({fileItem.fileTypeName})</p>
                                    ) : (
                                        <p>Belge Seçilmedi - ({fileItem.fileTypeName})</p>
                                    )}
                                </div>
                                <ImageUploader
                                    previewSrc={previewSrc}
                                    isPdf={isPdf} 
                                    onFileSelect={(files) => handleFileSelect(index, files)} 
                                />
                            </div>
                        )
                    }) 
                }
                </div>


                {/* <div className="input-grp">
                    <InputDate data={formData.uyeKayitTarihi} setData={(e) =>handleChange(e)} inputWidth={"440px"} labelText="Üye Kayıt Tarihi" name={"uyeKayitTarihi"}/>
                </div> */}
            </div>

            <div className="button-grp">
                <Btn width={"240px"} bgColor="#E85446" color="#fff" handleClick={handleSubmit}>{isLoadingCreateRegularDriver ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Ekle"}</Btn>
                <Btn width={"240px"} bgColor="transparent" color="#E85446" handleClick={() => dispatch(showModal(null))}>Vazgeç</Btn>
            </div>
        </div>
    </ModalContainer>
  )
}

export default AddRegularDriverModal